import handleResponse from "@/assets/handle-response";
import wretch from "wretch";

export default ({ state, commit }) => {
  state, wretch;
  return wretch("/api/all-meetings")
    .auth(state.email)
    .get()
    .json()
    .then(handleResponse)
    .then((meetings) => {
      state.meetings = meetings;
    })
    .catch((text) => {
      commit("setSnack", {
        visible: true,
        color: "error",
        text,
      });
    });
};
